import { call, cancelled, put, takeLatest } from "redux-saga/effects"
import axios from "axios"
import {
  deleteUserFailed,
  deleteUserSuccess,
  getOptionsSuccess,
  getUserCreateManduFailed,
  getUserCreateManduSuccess,
  getUsersManduFailed,
  getUsersManduSuccess,
  getUsersManduWatcher,
  saveUserFailed,
  saveUserSuccess,
  saveCompanyUserAccessManduFailed,
  saveCompanyUserAccessManduSuccess,
  deleteCompaniesUserAccessManduSuccess,
  deleteCompaniesUserAccessManduFailed,
} from "./actions"
import {
  DELETE_COMPANY_USER_ACCESS_MANDU_WATCHER,
  DELETE_USER_WATCHER,
  GET_OPTIONS_WATCHER,
  GET_USER_CREATE_MANDU_WATCHER,
  GET_USER_MANDU_WATCHER,
  RECOVERY_PASSWORD_WATCHER,
  SAVE_COMPANY_USER_ACCESS_MANDU_WATCHER,
  USER_CHANGE_ROLE_WATCHER,
  USER_SAVE_WATCHER,
} from "./constants"
import { LOCAL_TOKEN } from "../../../../utils/storage"

// Get Users
function getUsersApi(params) {
  let url = "users/index-filter?q"
  if (params.payload) {
    if (params.payload.searchHistoryMeasurement) {
      url += `&full_name=${params.payload.searchHistoryMeasurement}`
    }
    if (params.payload.selectedService) {
      url += `&id[0]=${params.payload.selectedService}`
    } else {
      url += "&id[0]=3&id[1]=4"
    }
    if (params.payload.selectedModule) {
      url += `&id_platform=${params.payload.selectedModule}`
    }
  } else {
    url += "&id[0]=3&id[1]=4&"
  }
  return axios.request({
    method: "GET",
    cancelToken: params.token,
    headers: { Authorization: `Bearer ${LOCAL_TOKEN()}` },
    url: `${process.env.API_URL + url}`,
  })
}

// Delete User
function deleteUserApi(params) {
  const url = `users/${params.payload.user_id}`
  return axios.request({
    method: "DELETE",
    cancelToken: params.token,
    headers: { Authorization: `Bearer ${LOCAL_TOKEN()}` },
    url: `${process.env.API_URL + url}`,
  })
}

// Save User
function saveUserApi(params) {
  let url = "users/"
  if (
    params.payload.id ||
    (params.payload instanceof FormData && params.payload.get("id"))
  ) {
    if (params.payload instanceof FormData) {
      params.payload.append("_method", "PUT")
      // params.payload.id = params.payload.get('id')
      if (params.payload.get("profile_picture") == "null") {
        params.payload.delete("profile_picture")
        params.payload.append("profile_picture_delete", true)
      }
    }
    url = `users/${params.payload.id || params.payload.get("id")}`
    params.payload._method = "PUT"
    delete params.payload.id
  } else {
    params.payload.id_gender = 3
  }
  return axios.request({
    method: "POST",
    cancelToken: params.token,
    data: params.payload,
    headers: { Authorization: `Bearer ${LOCAL_TOKEN()}` },
    url: `${process.env.API_URL + url}`,
  })
}

// Save User
function recoveryPasswordApi(params) {
  const url = "password/reset/sendlink"
  return axios.request({
    method: "POST",
    cancelToken: params.token,
    data: params.payload,
    headers: { Authorization: `Bearer ${LOCAL_TOKEN()}` },
    url: `${process.env.API_URL + url}`,
  })
}

function getUserCreateApi(params) {
  const url = "users/create"
  return axios.request({
    method: "GET",
    cancelToken: params.token,
    headers: { Authorization: `Bearer ${LOCAL_TOKEN()}` },
    url: `${process.env.API_URL + url}`,
  })
}

function saveCompanyUserAccessApi(params) {
  const url = `users/${params.payload.id ||
    params.payload.get("id")}/companies/access`
  return axios.request({
    method: "POST",
    cancelToken: params.token,
    data: params.payload,
    headers: { Authorization: `Bearer ${LOCAL_TOKEN()}` },
    url: `${process.env.API_URL + url}`,
  })
}

function deleteCompanyUserAccessApi(params) {
  const url = `users/${params.payload.id ||
    params.payload.get("id")}/companies/access`
  return axios.request({
    method: "DELETE",
    cancelToken: params.token,
    data: params.payload,
    headers: { Authorization: `Bearer ${LOCAL_TOKEN()}` },
    url: `${process.env.API_URL + url}`,
  })
}

export function* getUserCreateSaga(params = false) {
  const cancelSource = axios.CancelToken.source()
  try {
    params.token = cancelSource.token
    const { data } = yield call(getUserCreateApi, params)
    yield put(
      getUserCreateManduSuccess(data.data.result ? data.data.result : data.data)
    )
  } catch (e) {
    yield put(getUserCreateManduFailed([""]))
  } finally {
    if (yield cancelled()) {
      cancelSource.cancel()
    }
  }
}

export function* saveCompanyUserAccessSaga(params = false) {
  const cancelSource = axios.CancelToken.source()
  try {
    params.token = cancelSource.token
    const data = yield call(saveCompanyUserAccessApi, params)
    yield put(
      saveCompanyUserAccessManduSuccess(
        data.data.result ? data.data.result : data.data
      )
    )
    returnMessage(data)
  } catch (e) {
    returnMessage(e)
    yield put(saveCompanyUserAccessManduFailed([""]))
  } finally {
    if (yield cancelled()) {
      cancelSource.cancel()
    }
  }
}

export function* deleteCompanyUserAccessSaga(params = false) {
  const cancelSource = axios.CancelToken.source()
  try {
    params.token = cancelSource.token
    const data = yield call(deleteCompanyUserAccessApi, params)
    yield put(
      deleteCompaniesUserAccessManduSuccess(
        data.data.result ? data.data.result : data.data
      )
    )
    returnMessage(data)
  } catch (e) {
    returnMessage(e)
    yield put(deleteCompaniesUserAccessManduFailed([""]))
  } finally {
    if (yield cancelled()) {
      cancelSource.cancel()
    }
  }
}

export function* getUsersSaga(params = false) {
  const cancelSource = axios.CancelToken.source()
  try {
    params.token = cancelSource.token
    const { data } = yield call(getUsersApi, params)
    yield put(
      getUsersManduSuccess(data.data.result ? data.data.result : data.data)
    )
  } catch (e) {
    returnMessage(e)
    yield put(getUsersManduFailed(data))
  } finally {
    if (yield cancelled()) {
      cancelSource.cancel()
    }
  }
}

export function* saveUsersSaga(params = false) {
  const cancelSource = axios.CancelToken.source()
  try {
    params.token = cancelSource.token
    const data = yield call(saveUserApi, params)
    returnMessage(data)
    yield put(getUsersManduWatcher())
    yield put(saveUserSuccess())
  } catch (e) {
    returnMessage(e)
    yield put(saveUserFailed())
  } finally {
    if (yield cancelled()) {
      cancelSource.cancel()
    }
  }
}

export function* deleteUserSaga(params = false) {
  const cancelSource = axios.CancelToken.source()
  try {
    params.token = cancelSource.token
    const data = yield call(deleteUserApi, params)
    yield put(getUsersManduWatcher())
    yield put(deleteUserSuccess({}))
    returnMessage(data)
  } catch (e) {
    returnMessage(e)
    yield put(deleteUserFailed({}))
  } finally {
    if (yield cancelled()) {
      cancelSource.cancel()
    }
  }
}

// Get Options
function getOptionsApi(params) {
  const url = "companies/create"
  return axios.request({
    method: "GET",
    cancelToken: params.token,
    headers: { Authorization: `Bearer ${LOCAL_TOKEN()}` },
    url: `${process.env.API_URL + url}`,
  })
}

export function* getOptionsSaga(params = false) {
  const cancelSource = axios.CancelToken.source()
  try {
    params.token = cancelSource.token
    const { data, status } = yield call(getOptionsApi, params)
    if (status === 200) {
      yield put(getOptionsSuccess(data))
    }
  } catch (e) {
    returnMessage(e)
  } finally {
    if (yield cancelled()) {
      cancelSource.cancel()
    }
  }
}

export function* recoveryPasswordSaga(params = false) {
  const cancelSource = axios.CancelToken.source()
  try {
    params.token = cancelSource.token
    const data = yield call(recoveryPasswordApi, params)
    returnMessage(data)
  } catch (e) {
    returnMessage(e)
  } finally {
    if (yield cancelled()) {
      cancelSource.cancel()
    }
  }
}

export function* userChangeRoleSaga(params = false) {
  const cancelSource = axios.CancelToken.source()
  try {
    params.token = cancelSource.token
    const data = yield call(saveUserApi, params)
    yield put(getUsersManduWatcher())
    returnMessage(data)
  } catch (e) {
    returnMessage(e)
  } finally {
    if (yield cancelled()) {
      cancelSource.cancel()
    }
  }
}

// Individual exports for testing
export default function* homeSaga() {
  yield takeLatest(GET_USER_MANDU_WATCHER, getUsersSaga)
  yield takeLatest(USER_SAVE_WATCHER, saveUsersSaga)
  yield takeLatest(DELETE_USER_WATCHER, deleteUserSaga)
  yield takeLatest(RECOVERY_PASSWORD_WATCHER, recoveryPasswordSaga)
  yield takeLatest(GET_OPTIONS_WATCHER, getOptionsSaga)
  yield takeLatest(USER_CHANGE_ROLE_WATCHER, userChangeRoleSaga)
  yield takeLatest(GET_USER_CREATE_MANDU_WATCHER, getUserCreateSaga)
  yield takeLatest(
    SAVE_COMPANY_USER_ACCESS_MANDU_WATCHER,
    saveCompanyUserAccessSaga
  )
  yield takeLatest(
    DELETE_COMPANY_USER_ACCESS_MANDU_WATCHER,
    deleteCompanyUserAccessSaga
  )
}
